import { combineReducers } from "redux";
import listaPedidos from "./slices/listaPedidos.slice";

const reducer = combineReducers({
  listaPedidos,
});

export default reducer;
